"use strict";
'use client';
exports.__esModule = true;
exports.Snackbar = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var snackbar_style_1 = require("./snackbar.style");
var Snackbar = function (_a) {
    var open = _a.open, onClose = _a.onClose, children = _a.children, _b = _a.anchorOrigin, anchorOrigin = _b === void 0 ? { vertical: 'bottom', horizontal: 'left' } : _b, _c = _a.autoHideDuration, autoHideDuration = _c === void 0 ? 8000 : _c;
    (0, react_1.useEffect)(function () {
        if (open) {
            setTimeout(function () {
                onClose();
            }, autoHideDuration);
        }
    }, [open]);
    return (react_1["default"].createElement("div", { className: (0, class_names_1["default"])("".concat(open ? 'fixed' : 'hidden', " flex justify-center items-center bg-transparent z-[999999999999] m-2"), (0, snackbar_style_1.ANCHOR_ORIGIN)(anchorOrigin)) }, children));
};
exports.Snackbar = Snackbar;
exports["default"] = exports.Snackbar;
//# sourceMappingURL=snackbar.js.map